import { ErrorPage401 } from './ErrorPage401';
import { ErrorPage404 } from './ErrorPage404';
import { ErrorPage500 } from './ErrorPage500';
import { ErrorPage503 } from './ErrorPage503';
import { ErrorPageGeneric } from './ErrorPageGeneric';
import { Flex } from '../Layout';

export type ErrorPageProps = {
  type?: number;
  title?: string;
  message?: string;
  links?: { linkText: string; linkUrl: string }[];
};

export const ErrorPage = ({ type, ...rest }: ErrorPageProps) => {
  const ErrorPageContent = () => {
    switch (type) {
      case 401:
        return <ErrorPage401 {...rest} />;
      case 404:
        return <ErrorPage404 {...rest} />;
      case 500:
        return <ErrorPage500 {...rest} />;
      case 503:
        return <ErrorPage503 {...rest} />;
      default:
        return <ErrorPageGeneric {...rest} />;
    }
  };

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      rowGap={40}
      textAlign="center"
      marginTop={80}
      marginBottom={120}
      marginRight="auto"
      marginLeft="auto"
      maxWidth={[375, 768, 784]}
    >
      <ErrorPageContent />
    </Flex>
  );
};
